import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import './Home.css';
import { GlobalContext } from "../context/GlobalContext";
import { useLocation } from "react-router-dom";
const API_KEY = "c789db961f4419d16acc7a651958ff4f";
const BASE_URL = "https://api.themoviedb.org/3";

const Home = () => {
  const { addToWatchlist } = useContext(GlobalContext);
  const [query, setQuery] = useState("");
  const [movies, setMovies] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [trailerKey, setTrailerKey] = useState(null);
  const location = useLocation();

useEffect(() => {
  // Reset search and reload trending when route is "/"
  if (location.pathname === "/") {
    setQuery("");
    setMovies([]);
    setPage(1);
    setSelectedMovie(null);
    fetchTrendingMovies(1); // fetch page 1 again
  }
}, [location]);
  

  // 🔁 Fetch movies whenever page or query changes
  useEffect(() => {
  if (!query.trim()) {
    fetchTrendingMovies();
  } else if (page > 1) {
    fetchSearchResults();
  }
}, [page]);

  // 🔍 Handle search form submit
  const handleSearch = (e) => {
  e.preventDefault();

  if (!query.trim()) {
    // If search is empty, reset trending
    setPage(1);
    fetchTrendingMovies(1);
    return;
  }

  // Otherwise, start fresh search
  setPage(1);
  setMovies([]);
  fetchSearchResults(1); // 👈 fetch page 1 directly
};

  // 📥 Fetch trending
  const fetchTrendingMovies = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/discover/movie?api_key=${API_KEY}&page=${page}`
      );

      const newMovies = response.data.results;
      setMovies((prev) =>
        page === 1 ? newMovies : [...prev, ...newMovies]
      );
      setTotalPages(response.data.total_pages);
    } catch (error) {
      console.error("Error fetching trending movies", error);
    }
  };

  // 📥 Fetch search results
 const fetchSearchResults = async (pageNum = page) => {    
  try {
    const response = await axios.get(
      `${BASE_URL}/search/movie?api_key=${API_KEY}&query=${query}&page=${pageNum}`
    );

    const newMovies = response.data.results;
    setMovies((prev) =>
      pageNum === 1 ? newMovies : [...prev, ...newMovies]
    );
    setTotalPages(response.data.total_pages);
  } catch (error) {
    console.error("Error searching movies", error);
  }
};

  // 📽️ Load trailer on click
  const handleMovieClick = async (movie) => {
    setSelectedMovie(movie);
    setTrailerKey(null);

    try {
      const res = await axios.get(
        `${BASE_URL}/movie/${movie.id}/videos?api_key=${API_KEY}`
      );

      const youtubeTrailer = res.data.results.find(
        (vid) => vid.site === "YouTube" && vid.type === "Trailer"
      );

      if (youtubeTrailer) {
        setTrailerKey(youtubeTrailer.key);
      }
    } catch (err) {
      console.error("Failed to load trailer", err);
    }
  };

  // 🧲 Infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      const bottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 200;

      if (bottom && page < totalPages) {
        setPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, totalPages]);

  return (
    <div className="container">
      {/* 🔍 Search */}
      <form onSubmit={handleSearch}>
        <input
          type="text"
          placeholder="Search movies..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button type="submit">Search</button>
      </form>

      {/* 🎬 Movie Grid */}
      <div className="movie-grid">
        {movies.length>0 ? movies.filter((movie) => movie.poster_path) 
        .map((movie) => (
          <div
            className="movie-card"
            key={movie.id}
            onClick={() => handleMovieClick(movie)}
          >
            <img
              src={
                movie.poster_path
                  ? `https://image.tmdb.org/t/p/w300${movie.poster_path}`
                  : "https://via.placeholder.com/300x450?text=No+Image"
              }
              alt={movie.title}
            />
            <h4>{movie.title}</h4>
            <button
              onClick={(e) => {
                e.stopPropagation();
                addToWatchlist(movie);
              }}
            >
              Add to Watchlist
            </button>
          </div>
        )):(<div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "calc(100vh - 200px)", // or adjust to your layout
      width: "100%",
      fontSize: "40px",
      fontFamily: "serif",
      textAlign: "center",
    }}>no results</div>)} 
      </div>

      {/* 🎞️ Movie Modal */}
      {selectedMovie && (
        <div className="movie-modal" onClick={() => setSelectedMovie(null)}>
          <div className="movie-modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={
                selectedMovie.poster_path
                  ? `https://image.tmdb.org/t/p/w300${selectedMovie.poster_path}`
                  : "https://via.placeholder.com/300x450?text=No+Image"
              }
              alt={selectedMovie.title}
            />
            <h2>{selectedMovie.title}</h2>

            {/* Trailer */}
            {trailerKey ? (
              <div style={{ margin: "20px 0" }}>
                <iframe
                  width="100%"
                  height="250"
                  src={`https://www.youtube.com/embed/${trailerKey}`}
                  title="Trailer"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            ) : (
              <p style={{ color: "#ccc" }}>No trailer available.</p>
            )}

            <p><strong>⭐ Rating:</strong> {selectedMovie.vote_average} / 10</p>
            <p><strong>📅 Release Date:</strong> {selectedMovie.release_date}</p>
            <p><strong>🌍 Original Language:</strong> {selectedMovie.original_language}</p>

            {selectedMovie.overview && (
              <p style={{ marginTop: "15px" }}>
                <strong>📝 Overview:</strong><br />{selectedMovie.overview}
              </p>
            )}

            <button onClick={() => setSelectedMovie(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
